import * as util from "./util.js"
import axios from "axios";

var gauth;
async function init() {
    if (gauth != null)
        return;
    await util.loadScript("https://apis.google.com/js/platform.js");
    await loadAuth();
}

function loadAuth() {
    return new Promise((resolve) => {
        window.gapi.load('auth2', resolve);
    });
}

export async function login(kingdomId, worldId) {
    await init();
    gauth = await window.gapi.auth2.init({
        client_id: '844727555882-1j7bt4qbkkniu3e4d6a5muqv4668p4la.apps.googleusercontent.com'
    });
    var options = new window.gapi.auth2.SigninOptionsBuilder();
    options.setPrompt('select_account');
    await gauth.signIn(options);

    let token = gauth.currentUser.get().getAuthResponse().id_token;

    let payload = {token: token, authType: 'google', fromKlay: {kingdomId: kingdomId, worldId: worldId}};

    let ret = await axios.post(
        `https://lok-api-live.leagueofkingdoms.com/api/auth/login`,
        {json: JSON.stringify(payload)}
      );

      console.log(ret);

      if (ret.data.result == false) {
        alert("이미 글로벌 서버에 있는 계정입니다. 다른 계정으로 시도해 주세요.")
      }
      else {
          location.reload();
      }
}

export async function logout() {
    await init();
    gauth.signOut();
}

//NOTE:바로 로그인시 활성화
// if (gauth.isSignedIn.get())
//     return window.unity.response(gauth.currentUser.get().getAuthResponse().id_token);